import { css } from "@web/helpers/webComponents";

const styles: string = css`
    :host {
        display: block;
        position: absolute;
        inset: 0;
        pointer-events: none;
        overflow: hidden;
    }

    .vhs-container {
        position: absolute;
        inset: 0;
        overflow: hidden;
    }

    .scanlines {
        position: absolute;
        inset: 0;
        background: repeating-linear-gradient(
            to bottom,
            transparent 0px,
            transparent 2px,
            rgba(0, 0, 0, 0.15) 2px,
            rgba(0, 0, 0, 0.15) 4px
        );
        z-index: 1;
    }

    .vignette {
        position: absolute;
        inset: 0;
        background: radial-gradient(
            ellipse at center,
            transparent 0%,
            transparent 50%,
            rgba(0, 0, 0, 0.4) 90%,
            rgba(0, 0, 0, 0.8) 100%
        );
        z-index: 2;
    }

    .curvature {
        position: absolute;
        inset: -2%;
        width: 104%;
        height: 104%;
        border-radius: 50% / 10%;
        box-shadow: inset 0 0 100px 20px rgba(0, 0, 0, 0.5);
        z-index: 3;
    }

    .chromatic-aberration {
        position: absolute;
        inset: 0;
        background: linear-gradient(
            90deg,
            rgba(24, 22, 22, 0.03) 0%,
            transparent 50%,
            rgba(97, 97, 97, 0.03) 100%
        );
        z-index: 4;
    }

    .flicker {
        position: absolute;
        inset: 0;
        background: transparent;
        animation: flicker 0.15s infinite;
        z-index: 5;
    }

    @keyframes flicker {
        0% {
            opacity: 0.97;
        }
        50% {
            opacity: 1;
        }
        100% {
            opacity: 0.98;
        }
    }

    .tracking {
        position: absolute;
        inset: 0;
        background: repeating-linear-gradient(
            to bottom,
            transparent 0%,
            transparent 50%,
            rgba(255, 255, 255, 0.01) 50%,
            transparent 51%
        );
        animation: tracking 8s linear infinite;
        z-index: 6;
    }

    @keyframes tracking {
        0% {
            transform: translateY(-100%);
        }
        100% {
            transform: translateY(100%);
        }
    }

    .noise {
        position: absolute;
        inset: -50%;
        width: 200%;
        height: 200%;
        background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
        opacity: 0.03;
        animation: noise 0.2s steps(5) infinite;
        z-index: 7;
    }

    @keyframes noise {
        0% {
            transform: translate(0, 0);
        }
        20% {
            transform: translate(-5%, 5%);
        }
        40% {
            transform: translate(5%, -5%);
        }
        60% {
            transform: translate(-2%, 2%);
        }
        80% {
            transform: translate(2%, -2%);
        }
        100% {
            transform: translate(0, 0);
        }
    }

    .glow {
        position: absolute;
        inset: 0;
        box-shadow: inset 0 0 60px 10px rgba(100, 150, 255, 0.05);
        z-index: 8;
    }
`;

class VhsFrameComponent extends HTMLElement {
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            <div class="vhs-container">
                <div class="scanlines"></div>
                <div class="vignette"></div>
                <div class="curvature"></div>
                <div class="chromatic-aberration"></div>
                <div class="flicker"></div>
                <div class="tracking"></div>
                <div class="noise"></div>
                <div class="glow"></div>
            </div>
        `;
    }
}

// This VHS effect was found and copied from codepen.io as it's
// very time-consuming to make your own and not the main focus of this project

customElements.define("vhs-frame", VhsFrameComponent);
